import { useTranslation } from 'react-i18next';

import { useToast } from '@/hooks/use-toast';
import { useMutation } from '@apollo/client/react';

import {
  CsvTemplate,
  GetCsvTemplateDocument,
} from '../graphql/generated/graphql';
import { mapI18nLanguageToLanguageIso6391 } from '../utils';

export const useDownloadTemplate = () => {
  const { t, i18n } = useTranslation();
  const { toast } = useToast();
  const [getTemplate] = useMutation(GetCsvTemplateDocument);

  const downloadTemplate = async (templateId: CsvTemplate) => {
    const displayError = () => {
      toast({
        title: t('general.error'),
        description: t('hooks.download_template_error'),
        variant: 'destructive',
      });
    };
    try {
      const { data } = await getTemplate({
        variables: {
          templateId,
          language: mapI18nLanguageToLanguageIso6391(i18n.language),
        },
      });
      if (data?.exportDealCsvTemplate.__typename === 'MutationSuccess') {
        const content = data.exportDealCsvTemplate.id;
        const blob = new Blob([content], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `template.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error('Mutation failed');
      }
    } catch (error) {
      console.error(error);
      displayError();
    }
  };

  const downloadCouponCodesTemplate = () =>
    downloadTemplate(CsvTemplate.CouponCodes);

  const downloadClassicTemplate = () => downloadTemplate(CsvTemplate.Classic);

  const downloadCouponTemplate = () => downloadTemplate(CsvTemplate.Coupon);

  return {
    downloadClassicTemplate,
    downloadCouponCodesTemplate,
    downloadCouponTemplate,
  };
};
